import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

export default function ShareModal({ game, onClose }) {
  const [copied, setCopied] = useState(false);
  const shareLink = `${window.location.origin}/game-player-screen?id=${game?.id}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const el = document.createElement('textarea');
      el.value = shareLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleSocial = (platform) => {
    const text = encodeURIComponent(`Check out "${game?.title}" on GameForge!`);
    const url = encodeURIComponent(shareLink);
    const urls = {
      Twitter: `https://twitter.com/intent/tweet?text=${text}&url=${url}`,
      Discord: `https://discord.com/`,
      Reddit: `https://reddit.com/submit?url=${url}&title=${text}`,
      WhatsApp: `https://wa.me/?text=${text}%20${url}`,
      Email: `mailto:?subject=${text}&body=${url}`,
      Link: null,
    };
    if (platform === 'Link') {
      handleCopy();
      return;
    }
    if (urls[platform]) window.open(urls[platform], '_blank', 'noopener,noreferrer');
  };

  if (!game) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}
      onClick={(e) => e?.target === e?.currentTarget && onClose()}
    >
      <div
        className="w-full max-w-sm rounded-2xl overflow-hidden animate-bounce-in"
        style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)', boxShadow: 'var(--shadow-xl)' }}
      >
        <div className="flex items-center justify-between p-5 border-b" style={{ borderColor: 'var(--color-border)' }}>
          <h2 className="text-base font-bold" style={{ color: 'var(--color-foreground)', fontFamily: 'var(--font-heading)' }}>Share "{game?.title}"</h2>
          <button onClick={onClose} className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-[var(--color-muted)] transition-all">
            <Icon name="X" size={16} color="var(--color-muted-foreground)" />
          </button>
        </div>
        <div className="p-5 flex flex-col gap-4">
          <div className="flex gap-2">
            <div
              className="flex-1 px-3 py-2.5 rounded-xl text-xs overflow-hidden text-ellipsis whitespace-nowrap"
              style={{ background: 'var(--color-muted)', color: 'var(--color-muted-foreground)', fontFamily: 'var(--font-data)', border: '1px solid var(--color-border)' }}
            >
              {shareLink}
            </div>
            <button
              onClick={handleCopy}
              className="px-3 py-2 rounded-xl text-xs font-semibold flex items-center gap-1.5 transition-all"
              style={{
                background: copied ? 'rgba(16,185,129,0.1)' : 'rgba(99,102,241,0.1)',
                color: copied ? 'var(--color-success)' : 'var(--color-primary)',
                border: `1px solid ${copied ? 'var(--color-success)' : 'var(--color-primary)'}`,
              }}
            >
              <Icon name={copied ? 'Check' : 'Copy'} size={13} />
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
          <div className="grid grid-cols-3 gap-2">
            {[
              { label: 'Twitter', icon: 'Twitter', color: '#1DA1F2' },
              { label: 'Discord', icon: 'MessageCircle', color: '#5865F2' },
              { label: 'Reddit', icon: 'Share2', color: '#FF4500' },
              { label: 'WhatsApp', icon: 'Phone', color: '#25D366' },
              { label: 'Email', icon: 'Mail', color: '#6366F1' },
              { label: 'Link', icon: 'Link', color: '#8B5CF6' },
            ]?.map((s) => (
              <button
                key={s?.label}
                onClick={() => handleSocial(s?.label)}
                className="flex flex-col items-center gap-1.5 py-3 rounded-xl text-xs font-semibold transition-all hover:opacity-80 active:scale-95"
                style={{ background: `${s?.color}18`, color: s?.color, border: `1px solid ${s?.color}30`, fontFamily: 'var(--font-caption)' }}
              >
                <Icon name={s?.icon} size={18} color={s?.color} />
                {s?.label}
              </button>
            ))}
          </div>
          <Button variant="outline" onClick={onClose} fullWidth>Close</Button>
        </div>
      </div>
    </div>
  );
}